<div class="rfr-edit-shell">

  <div class="rfr-edit-header">
    <button class="rfr-back-btn" (click)="onCancel()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
      </svg>
    </button>
    <div>
      <h2 class="rfr-edit-title">Excluding Users for RFR Creation</h2>
      <p class="rfr-edit-sub">Add or remove employees excluded from RFR creation</p>
    </div>
  </div>

  <div class="rfr-alert error" *ngIf="loadError">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
    </svg>
    {{ loadError }}
  </div>

  <div class="rfr-alert success" *ngIf="successMessage">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </svg>
    {{ successMessage }}
  </div>

  <div class="rfr-edit-card rfr-two-col">

    <!-- Left: dropdown to add -->
    <div class="rfr-col-left">
      <div class="rfr-field">
        <label class="rfr-label"><i class="fas fa-user-plus"></i> Add Employee</label>
        <div *ngIf="isLoadingEmps" class="rfr-select-loading">
          <div class="rfr-mini-spinner"></div> Loading employees...
        </div>
        <ng-select
          *ngIf="!isLoadingEmps"
          class="rfr-multi-add"
          [items]="employees"
          bindLabel="employee_name"
          bindValue="employee_id"
          [(ngModel)]="selectedEmployeeIds"
          (change)="onSelectionChange(selectedEmployeeIds)"
          [multiple]="true"
          [hideSelected]="false"
          [closeOnSelect]="false"
          placeholder="Search and select an employee"
          [searchable]="true"
          [clearable]="false">
        </ng-select>
        <small class="rfr-field-hint">Selecting an employee adds them to the excluded list on the right</small>
      </div>
    </div>

    <!-- Right: selected employees -->
    <div class="rfr-col-right">
      <div class="rfr-selected-header">
        <label class="rfr-label"><i class="fas fa-user-slash"></i> Excluded Employees ({{ selectedEmployees.length }})</label>
        <button
          class="rfr-clear-all-btn"
          *ngIf="selectedEmployees.length > 0"
          (click)="clearAllEmployees()">
          Clear All
        </button>
      </div>
      <div class="rfr-selected-list">
        <div *ngIf="selectedEmployees.length === 0" class="rfr-empty-sm">No employees excluded yet.</div>
        <div class="rfr-selected-item" *ngFor="let emp of selectedEmployees">
          <span>{{ emp.employee_name }}</span>
          <button class="rfr-remove-btn" (click)="removeEmployee(emp)" title="Remove">&times;</button>
        </div>
      </div>
    </div>

  </div>

  <div class="rfr-actions">
    <button class="rfr-btn-cancel" (click)="onCancel()">Cancel</button>
    <button class="rfr-btn-save" (click)="onSave()" [disabled]="isSaving">
      <div class="rfr-mini-spinner" *ngIf="isSaving"></div>
      <svg *ngIf="!isSaving" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
      </svg>
      {{ isSaving ? 'Saving...' : 'Save Changes' }}
    </button>
  </div>

</div>